import React from "react";
import "./CardBorder.css";

type CardBorderProps = {
  children: React.ReactNode;
};

export default function CardBorder({ children }: CardBorderProps) {
  return (
    <div className="neon-card">
      <div className="neon-card__inner">{children}</div>
    </div>
  );
}
